import { render, staticRenderFns } from "./add-admin.vue?vue&type=template&id=e39f8a7a&scoped=true"
import script from "./add-admin.vue?vue&type=script&lang=js"
export * from "./add-admin.vue?vue&type=script&lang=js"
import style0 from "./add-admin.vue?vue&type=style&index=0&id=e39f8a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39f8a7a",
  null
  
)

export default component.exports